import request from "@/utils/request";

let PFID = 20000;

//商品分类
export function getCategories(){
    return request.post('/weidaoyun/shop/categoryTag/getCategoryIndex.jhtml',{
    })
}

//商品分类
export function getChildrenCategories(parentId, type){
    return request.get('/common/getCategorys.jhtml?parent=' + parentId + '&type=' + type,{
    })
}

//商品列表
export function getSkuList(topId, secondId, threeId, pageNumber, pageSize, keyword, orderType, brand) {
    let url = '/weidaoyun/shop/member/product/getXcxPurchaseList.jhtml';
    let params = {};
    params.desktop = '1';
    params.orderType = orderType;
    if (threeId != '' && threeId > 0) {
      params.threeCaras = threeId;
    } else {
      if (topId != '' && topId > 0 && (secondId == '' || secondId == 0)) {
        params.categoryId = "-" + topId;
      } else if (secondId != '' && secondId > 0) {
        params.categoryId = secondId;
      }
    }
    params.pageNumber = pageNumber;
    params.pageSize = pageSize;
    params.keyword = keyword;
    params.brand = brand;
    return request.get(url,params)
}


//获取商品列表
export function getGoodsList(pagenum,pagesize,val){
    return request.get('/api/public/v1/goods/search',{
        'pagenum': pagenum, 'pagesize': pagesize,'query': val
    })
}

//获取商品详情
export function getGoodsDetail(pfid, id){
    return request.post('/weidaoyun/shop/member/product/AutarkyProductDetail.jhtml?type=join&platformId=' + pfid + '&id=' + id,{

    })
}

//获取商品规格
export function getGoodsSkuList(pfid, id){
    return request.post('/weidaoyun/shop/member/product/addCartPro.jhtml?platformId=' + pfid + '&id=' + id,{

    })
}

//获取pc首页推荐分类
export function getPcIndexCategoryList(did){
    return request.post('/weidaoyun/shop/api/0025110≠S1BS3Wg≈k*π≈vS1πylSW≠ßS1BS3Wg≈kIBπeLSΩB.jhtml',{
      did:did
    })
}

//获取pc首页底部分类推荐
export function getRecommendList() {
    let url = '/weidaoyun/shop/member/esproduct/getRecommendList.jhtml';
    let params = {};
    params.desktop = '1';
    params.aggFiled = 'brand';
    return request.get(url,params)
}

//获取当前查询条件下的品牌
export function getBrandList(topId, secondId, threeId) {
    let url = '/weidaoyun/shop/member/esproduct/getBrandList.jhtml';
    let params = {};
    params.desktop = '1';
    params.orderType = '';
    params.aggFiled = 'brand';
    if (threeId != '' && threeId > 0) {
      params.threeCaras = threeId;
    } else {
      if (topId != '' && topId > 0 && (secondId == '' || secondId == 0)) {
        params.categoryId = "-" + topId;
      } else if (secondId != '' && secondId > 0) {
        params.categoryId = secondId;
      }
    }
    params.pageNumber = 1;
    params.pageSize = 50;
    params.keyword = '';
    return request.get(url,params)
}

//获取token
export function getToken() {
    let url = '/app/access.jhtml?t=' + new Date().getTime();
    let params = {};
    return request.get(url,params)
}

//获取public_key
export function getPublicKey(token) {
    let url = '/weidaoyun/shop/member/getkey.jhtml?token=' + token;
    let params = {};
    return request.get(url,params,false)
}

//获取public_key
export function getNewPublicKey() {
    let url = '/weidaoyun/shop/member/getkey.jhtml';
    let params = {};
    return request.get(url,params)
}

//登录
export function login(phone, password, code, token) {
    let url = '/weidaoyun/shop/member/weblogin.jhtml?token=' + token;
    let params = {};
    params.username = phone;
    params.password = password;
    params.captcha = code;
    return request.post(url,params,false)
}

//注册
export function webregister(phone, password, code, token, mcode) {
    let url = '/weidaoyun/shop/member/webregister.jhtml?token=' + token;
    let params = {};
    params.phone = phone;
    params.password = password;
    params.vcode = code;
    params.mcode = mcode;
    return request.post(url,params,false)
}

//验证码
export function getcode(phone, token, captcha) {
    let url = '/weidaoyun/shop/goldshop/webGetcode.jhtml?token=' + token + '&type=1&phone=' + phone + '&captcha=' + captcha;
    return request.post(url,{},false)
}

//检查登录状
export function checkLogined() {
    let url = '/weidaoyun/shop/member/check.jhtml'
    let params = {};
    return request.get(url,params)
}

//购物车列表
export function cartList(platformId, pageNumber, pageSize) {
    let url = '/weidaoyun/shop/cart/view.jhtml?platformId=' + platformId;
    let params = {};
    params.pageNumber = pageNumber;
    params.pageSize = pageSize;
    return request.post(url,params)
}

//购物车结算信息
export function cartPaymentInfo(platformId) {
    let url = '/weidaoyun/shop/cart/getPaymentInfo.jhtml?platformId=' + platformId;
    let params = {};
    return request.post(url,params)
}

//购物车商品数量编辑
export function eidtCart(platformId, id, quantity) {
    let url = '/weidaoyun/shop/cart/edit.jhtml?platformId=' + platformId;
    let params = {};
    params.cartitemId = id;
    params.quantity = quantity;
    return request.post(url,params)
}

//购物车商品选中
export function eidtCartSelect(platformId, list) {
    let url = '/weidaoyun/shop/cart/select.jhtml?platformId=' + platformId;
    let params = {};
    params.list = list;
    return request.post(url,params)
}

//购物车商品选中
export function delCartItem(platformId, id) {
    let url = '/weidaoyun/shop/cart/delete.jhtml?platformId=' + platformId;
    let params = {};
    params.cartItemId = id;
    return request.post(url,params)
}

//加入购物车
export function addCartItem(platformId, id, quantity) {
    let url = '/weidaoyun/shop/cart/add.jhtml?platformId=' + platformId;
    let params = {};
    params.id = id;
    params.quantity = quantity;
    return request.post(url,params)
}

//获取购物车商品数量
export function getCartItemNum(platformId, id, quantity) {
    let url = '/weidaoyun/shop/cart/catNum.jhtml?platformId=' + platformId;
    let params = {};
    return request.post(url,params)
}

//结算信息支付信息
export function orderPaymentInfo(platformId, params) {
    let paramsstr = "";
    for (let key in params) {
      paramsstr += '&' + key + '=' + params[key];
    }
    let url = '/weidaoyun/shop/cart/getPaymentInfo.jhtml?platformId=' + platformId + paramsstr;
    return request.post(url,{})
}

//结算信息订单信息
export function orderCheck(platformId, params) {
    let url = '/weidaoyun/shop/order/check.jhtml?platformId=' + platformId;
    return request.post(url,params)
}

//结算信息订单结算
export function orderCheckOut(platformId, params) {
    let url = '/weidaoyun/shop/order/check_out.jhtml?platformId=' + platformId;
    return request.post(url,params)
}

//获取用户收货地址
export function receiverList() {
    let url = '/weidaoyun/shop/members/findListDeliveryAddress.jhtml';
    let params = {};
    return request.get(url,params)
}

//获取用户订单列表
export function gerOrderList(pageNumber, pageSize, type) {
    let url = '/weidaoyun/shop/member/order/list.jhtml';
    let params = '?pageNumber=' + pageNumber;
    params += '&pageSize=' + pageSize;
    params += '&type=' + type;
    return request.get(url + params, {})
}

//获取京东物流信息
export function getOrderTract(orderId) {
  let url = '/weidaoyun/open/jdvop/getOrderTract.jhtml?orderId=' + orderId
  return request.post(url, {})
}

//获取京东售后信息
export function getOrderAftersales() {
  let url = '/weidaoyun/open/jdvop/getOrderAftersalesPc.jhtml'
  return request.post(url, {})
}

//获取用户信息
export function userInfo() {
  let url = '/weidaoyun/shop/income/getMemberInfom.jhtml'
  return request.post(url, {})
}

//获取省数据
export function getRootAreas() {
  let url = '/common/getAreaRoot.jhtml'
  return request.get(url, {})
}
//获取下级区域数据
export function getChildrenAreas(parent) {
  let url = '/common/getAreas.jhtml?parent=' + parent
  return request.get(url, {})
}

//保存收货地址
export function saveReceiver(obj) {
  let url = '/weidaoyun/shop/members/addReceiver.jhtml'
  let params = {"areaId":obj.area,"area_name":obj.area_name,"name":obj.consignee,"tel":obj.phone,"address":obj.address,"def":obj.checked}
  return request.post(url, params)
}

//更新收货地址
export function updateReceiver(obj) {
  let url = '/weidaoyun/shop/members/editReceiver.jhtml'
  let params = {"id":obj.id,"areaId":obj.area,"area_name":obj.area_name,"name":obj.consignee,"tel":obj.phone,"address":obj.address,"def":obj.checked}
  return request.post(url, params)
}

//删除收货地址
export function deleteReceiver(id) {
  let url = '/weidaoyun/shop/members/deleteReceiver.jhtml?id=' + id
  return request.get(url, {})
}


//获取订单明细
export function getOrderDetail(pfid, sn) {
  let url = '/weidaoyun/shop/member/order/getOrderDetail.jhtml?platformId=' + pfid + '&sn=' + sn;
  return request.get(url, {})
}

//尝试取消订单
export function tryCancelOrder(pfid, sn) {
  let url = '/weidaoyun/shop/member/order/cancel.jhtml?platformId=' + pfid + '&sn=' + sn;
  return request.get(url, {})
}

//获取首页广告
export function findAdList() {
  let url = '/weidaoyun/shop/ad/find.jhtml?platformId=' + PFID;
  return request.post(url, {})
}

//获取用户余额
export function getMemberGoodsMoneys() {
  let url = '/weidaoyun/shop/member/order/getMemberGoodsMoneys.jhtml';
  return request.post(url, {})
}

//获取用户余额清单
export function getMemberGoodsMoneysList(pageNumber, pageSize) {
  let url = '/weidaoyun/shop/member/order/memberGoodsMoneys.jhtml';
  return request.post(url, {pageNumber: pageNumber, pageSize: pageSize})
}

//修改登录密码
export function setPassword(oldPwd, password) {
  let url = '/weidaoyun/shop/member/setNewPassword.jhtml';
  return request.post(url, {oldPwd: oldPwd, password: password})
}

//获取七牛上传token
export function getUploadToken(oldPwd, password) {
  let url = '/weidaoyun/qiniuyun/getFileUploadToken.jhtml';
  return request.get(url, {})
}

//获取订单附件列表
export function orderAttachmentList(pfid, orderId) {
  let url = '/weidaoyun/shop/order/attachment/orderAttachmentList.jhtml';
  return request.post(url, {pfid: pfid, orderId: orderId})
}

//保存订单附件
export function saveOrderAttachment(params) {
  let url = '/weidaoyun/shop/order/attachment/saveOrderAttachment.jhtml';
  return request.post(url, params)
}

//删除订单附件
export function deleteOrderAttachment(pfid, id) {
  let url = '/weidaoyun/shop/order/attachment/deleteOrderAttachment.jhtml';
  return request.post(url, {pfid: pfid, id: id})
}

//获取合同批次列表
export function getOrderAttachmentMainList(state, pageNumber, pageSize) {
  let url = '/weidaoyun/shop/order/attachment/orderAttachmentMainList.jhtml'
  let params = {};
  params.mainStatus = state;
  params.pageNumber = pageNumber;
  params.pageSize = pageSize;
  return request.post(url, params)
}
//获取合同批次明细列表
export function getOrderAttachmentDetailList(mainId, pageNumber, pageSize) {
  let url = '/weidaoyun/shop/order/attachment/orderAttachmentDetailList.jhtml'
  let params = {};
  params.mainId = mainId;
  params.pageNumber = pageNumber;
  params.pageSize = pageSize;
  return request.post(url, params)
}
//获取合同主信息
export function findOrderAttachmentMain(mainId) {
  let url = '/weidaoyun/shop/order/attachment/findOrderAttachmentMain.jhtml'
  let params = {};
  params.id = mainId;
  return request.post(url, params)
}

// 查询发票详情 /weidaoyun/admin/api/0263111SWv3S1π*π≈vS1πySWv3S1πßπBgShΩ.jhtml
export function getInvoiceList() {
  let url = '/weidaoyun/shop/api/0257111SWv3S1π*π≈vS1πylSW≠IWv3S1π!πg≠π≈.jhtml'
  let params = {};
  return request.post(url, params)
}

// 添加发票抬头 weidaoyun/shop/api/0258111SWv3S1π*π≈vS1πyΩgvπIWv3S1π!πg≠π≈.jhtml?w=xAAAAXoq&token=016150e1-cd55-4911-8bc8-744bd7eccf8a
export function saveInvoice(params) {
  let url = '/weidaoyun/shop/api/0258111SWv3S1π*π≈vS1πyΩgvπIWv3S1π!πg≠π≈.jhtml'
  return request.post(url, params)
}

//获取私有链接
export function getPrivateUrl(fileUrl) {
  let url = '/weidaoyun/qiniuyun/getPrivateUrl.jhtml'
  let params = {};
  params.url = fileUrl;
  return request.post(url, params)
}

//获取公司信息
export function findTenderSupplyById() {
  let url = '/weidaoyun/shop/tendersupply/findTenderSupplyById.jhtml'
  let params = {};
  return request.post(url, params)
}

//获取公司快照信息
export function findTenderSupplySnapshootById() {
  let url = '/weidaoyun/shop/tendersupply/findTenderSupplySnapshootByMid.jhtml'
  let params = {};
  return request.post(url, params)
}


//保存公司信息
export function saveTenderSupply(params) {
  let url = '/weidaoyun/shop/tendersupply/saveTenderSupply.jhtml'
  return request.post(url, params)
}

//修改公司信息
export function updateTenderSupply(params) {
  let url = '/weidaoyun/shop/tendersupply/updateTenderSupply.jhtml'
  return request.post(url, params)
}

//提交公司信息
export function applyTenderSupply() {
  let url = '/weidaoyun/shop/tendersupply/applyTenderSupply.jhtml'
  return request.post(url, {})
}

//查询我的投标列表
export function findTenderMainApplyList(params) {
  let url = '/weidaoyun/shop/tendersupply/findTenderMainApplyList.jhtml'
  return request.post(url, params)
}

//查询我的中标列表
export function findTenderMainPublicityList(params) {
  let url = '/weidaoyun/shop/tendersupply/findTenderMainPublicityList.jhtml'
  return request.post(url, params)
}

//投标提交送审
export function applyTenderMainSupply(params) {
  let url = '/weidaoyun/shop/tendersupply/applyTenderMainSupply.jhtml'
  return request.post(url, params)
}

//申请投标
export function saveTenderMainApply(params) {
  let url = '/weidaoyun/shop/tendersupply/saveTenderMainApply.jhtml'
  return request.post(url, params)
}

//删除投标草稿
export function removeTenderMainApply(params) {
  let url = '/weidaoyun/shop/tendersupply/removeTenderMainApply.jhtml'
  return request.post(url, params)
}

//查询投标信息
export function findTenderMainApplyByMid(params) {
  let url = '/weidaoyun/shop/tendersupply/findTenderMainApplyByMid.jhtml'
  return request.post(url, params)
}

//保存附件
export function saveTenderMainAttachment(params) {
  let url = '/weidaoyun/shop/tendersupply/saveTenderMainAttachment.jhtml'
  return request.post(url, params)
}

//删除附件
export function removeTenderMainAttachment(id) {
  let url = '/weidaoyun/shop/tendersupply/removeTenderMainAttachment.jhtml?id=' + id
  return request.post(url, {})
}

//查询附件
export function findTenderMainAttachmentList(params) {
  let url = '/weidaoyun/shop/tendersupply/findTenderMainAttachmentList.jhtml'
  return request.post(url, params)
}

//查询附件
export function applyTenderAttachment(id) {
  let url = '/weidaoyun/shop/tendersupply/applyTenderAttachment.jhtml?id=' + id
  return request.post(url, {})
}

//查看招标公示
export function findTenderMainViewList(params) {
  let url = '/weidaoyun/shop/tendersupply/findTenderMainViewList.jhtml'
  return request.post(url, params)
}

//查看中标公示
export function findTenderMainPublicityViewList(params) {
  let url = '/weidaoyun/shop/tendersupply/findTenderMainPublicityViewList.jhtml'
  return request.post(url, params)
}

//查看招标公示
export function findTenderMainViewById(id) {
  let url = '/weidaoyun/shop/tendersupply/findTenderMainViewById.jhtml?id=' + id
  return request.post(url, {})
}

//查看中标公示
export function findTenderMainPublicityViewById(id) {
  let url = '/weidaoyun/shop/tendersupply/findTenderMainPublicityViewById.jhtml?id=' + id
  return request.post(url, {})
}


//查看供应商投标信息
export function getTenderMainApplyByMid(mainId) {
  let url = '/weidaoyun/shop/tendersupply/getTenderMainApplyByMid.jhtml?mainId=' + mainId
  return request.post(url, {})
}
